import type { ParsedInsightsFilters } from '@/lib/api/types/insights/filters';
import type { VarianceGroupBy } from '@/lib/api/types/insights/variance';

type InsightsQueryKeyParams = {
  filters?: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId?: number;
  orgId?: string;
  dateRange?: { from: string; to: string };
  planStartDate?: string;
};

type VarianceQueryKeyParams = InsightsQueryKeyParams & {
  groupBy: VarianceGroupBy[];
};

export const insightsQueryKeys = {
  scopeSize: {
    all: () => ['insightsScopeSize'] as const,
    byFilters: ({ filters, scopeItemId, loopId, orgId }: InsightsQueryKeyParams) => [
      'insightsScopeSize',
      orgId,
      loopId,
      filters,
      scopeItemId,
    ],
  },
  health: {
    all: () => ['insightsHealthSummary'] as const,
    summary: ({ filters, scopeItemId, loopId, orgId }: InsightsQueryKeyParams) => [
      'insightsHealthSummary',
      orgId,
      loopId,
      filters,
      scopeItemId,
    ],
    byItemIds: (itemIds: number[]) => ['insightsItemHealth', itemIds] as const,
    byItemId: (itemId: number) => ['insightsItemHealth', itemId] as const,
  },
  trends: {
    all: () => ['insightsTrendsProgress'] as const,
    progress: ({
      filters,
      scopeItemId,
      loopId,
      orgId,
      dateRange,
      planStartDate,
    }: InsightsQueryKeyParams) => [
      'insightsTrendsProgress',
      orgId,
      loopId,
      filters,
      scopeItemId,
      dateRange,
      planStartDate,
    ],
  },
  variance: {
    all: () => ['insightsVarianceBreakdown'] as const,
    breakdown: ({ filters, scopeItemId, loopId, orgId, groupBy }: VarianceQueryKeyParams) => [
      'insightsVarianceBreakdown',
      orgId,
      loopId,
      filters,
      scopeItemId,
      groupBy,
    ],
  },
} as const;
